import React from 'react';
import styled from 'styled-components';
import {css} from 'emotion';
import AppleLogo from '../SvgComponents/logos/AppleLogo';
import PlayStoreLogo from '../SvgComponents/logos/PlayStoreLogo';
import {Spring, animated} from 'react-spring/renderprops';

/* global tw */

const Wrapper = styled.a`
    ${tw`flex items-center justify-between relative overflow-hidden no-underline py-4 px-4 rounded cursor-pointer`};
    ${props => props.dark ? tw`text-black` : tw`text-white` };
    ${props => props.dark ? tw`border-color-black` : tw`border-color-white` };
    border: 1px solid;
    ${props => props.hideOnMobile && tw`hidden lg:flex`};
`
class DownloadAppButton extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            hovered: false,
        }
        this.handleClick = this.handleClick.bind(this)
    }
    handleClick = () => {
        console.log("clicked2",window)
        // eslint-disable-next-line
        analytics.track('Download App Clicked ', { category: 'Download Button', label: 'Clicked' });
    }
    render(){
        return(
            <Wrapper hideOnMobile={this.props.hideOnMobile} onClick={()=>{this.handleClick()}} className={this.props.className} dark={this.props.dark} href={
                 typeof window !== "undefined" && 
                 window.navigator.platform === "Win32" ? "https://play.google.com/store/apps/details?id=com.zyppys.customer" : "http://onelink.to/zyppys"} target="_blank">
                    Download App
                    {/* &#8377;250 off on App */}
                    <div>
                        <PlayStoreLogo dark={this.props.dark} height="24" className={css`${tw`mx-2`}`}/>
                        <AppleLogo dark={this.props.dark} height="24" className={css`${tw`mx-2`}`}/>
                    </div>
            </Wrapper>
        );
    }
}

export default DownloadAppButton;